import { Text } from '../../../components/shared/text';
import { formatNumberEuro } from '../../../project/helpers';
import { type WarrantyRequest } from '../../../store/warrantyRequest/warrantyRequestModels';

const WarrantyBasket: React.FC<{
  request: WarrantyRequest;
}> = ({ request }) => {
  let total = 0,
    totalEcoPart = 0,
    totalEcoContr = 0;

  return request?.articles?.length ? (
    <>
      <group data-text-size="12" >
        <group >
          <group data-align="center" data-wrap="no" data-gap="5" data-space="5">
            <group data-length="autofit" >
              <Text className="">garantie.demande.etapes.3.panier.article</Text>
            </group>
            <group data-length="60">
              <Text data-position="center" className="">
                garantie.demande.etapes.2.SelectArticles.qte
              </Text>
            </group>
            {request.typedemande === 'commande' && (
              <>
                <group data-length="70">
                  <Text data-position="right" className="">
                    garantie.demande.etapes.3.panier.prixhtu
                  </Text>
                </group>
                <group data-length="60">
                  <Text data-position="right" className="">
                    garantie.demande.etapes.3.panier.ecopart
                  </Text>
                </group>
                <group data-length="70">
                  <Text data-position="right" className="">
                    garantie.demande.etapes.3.panier.eco_contr
                  </Text>
                </group>
                <group data-length="60">
                  <Text data-position="right" className="">
                    garantie.demande.etapes.3.panier.total
                  </Text>
                </group>
              </>
            )}
          </group>
          <group>
            <separator horizontal="" />
          </group>
        </group>




        {request?.articles?.map((article) => {
          let eco_contr = Math.max(
            (article.articleReseau?.poids ?? 0) * (article.articleReseau?.pu_pmcb ?? 0) * article.pivot.quantite,
            0.01
          );

          let _total =
            parseFloat(article?.articleReseau?.prix_ht_remise?.toString?.() ?? '0') * article.pivot.quantite +
            (article?.articleReseau?.deee ?? 0) +
            eco_contr,
            isAvg = request?.garantie_type?.isAvg && request.satc_attente !== 'refusee';

          total += isAvg ? 0 : _total;
          totalEcoPart += isAvg ? 0 : article?.articleReseau?.deee;
          totalEcoContr += isAvg ? 0 : eco_contr;

          const qte = article.pivot.quantite;

          return (
            <group key={article.uuid}>
              <group data-align="start" data-space="5" data-gap="5">
                <group data-gap="5" data-length="autofit">
                  <text data-weight="800">[{article.reference}]</text>
                  <text  data-text-size="10" data-weight="800" data-wrap="wrap">
                    {article.libelle}
                  </text>
                </group>
                <group data-gap="5" data-length="60" data-align="center" >
                  <text data-wrap="wrap" data-position="center">
                    {qte}
                  </text>
                </group>

                {request.typedemande === 'commande' && (
                  <>
                    <group data-gap="5" data-length="70" data-position="left">
                      <Text data-position="right" className="">
                        {formatNumberEuro(isAvg ? 0 : article.articleReseau?.prix_ht_remise ?? 0, article.articleReseau?.reseau?.currency)}
                      </Text>
                    </group>
                    <group data-gap="5" data-length="60">
                      <Text data-position="right" className="">
                        {formatNumberEuro(isAvg ? 0 : article.articleReseau?.deee ?? 0, article.articleReseau?.reseau?.currency)}
                      </Text>
                    </group>
                    <group data-gap="5" data-length="70">
                      <Text data-position="right" className="">
                        {formatNumberEuro(isAvg ? 0 : eco_contr ?? 0, article.articleReseau?.reseau?.currency)}
                      </Text>
                    </group>
                    <group data-gap="5" data-length="60">
                      <Text data-position="right" className="">
                        {formatNumberEuro(isAvg ? 0 : _total, article.articleReseau?.reseau?.currency)}
                      </Text>
                    </group>
                  </>
                )}
              </group>
            </group>
          );
        })}

        <group>
          {request.typedemande === 'commande' && (
            <group data-direction="column" data-wrap="no" data-space-vertical="20" data-gap="5">
              <group data-wrap="no">
                <group data-length="autofit" data-hide=""></group>

                <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                  <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                    garantie.demande.etapes.3.panier.total
                  </Text>
                  <text data-length="80" data-text-align="right" data-space-horizontal="10">
                    {formatNumberEuro(total, request.reseau_commercial?.currency)}
                  </text>
                </group>
              </group>

              <group data-wrap="no">
                <group data-length="autofit" data-hide=""></group>

                <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                  <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                    garantie.demande.etapes.3.panier.totalEcopart
                  </Text>
                  <text data-length="80" data-text-align="right" data-space-horizontal="10">
                    {formatNumberEuro(totalEcoPart, request.reseau_commercial?.currency)}
                  </text>
                </group>
              </group>
              <group data-wrap="no">
                <group data-length="autofit" data-hide=""></group>

                <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                  <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                    garantie.demande.etapes.3.panier.totalEcocontr
                  </Text>
                  <text data-length="80" data-text-align="right" data-space-horizontal="10">
                    {formatNumberEuro(totalEcoContr, request.reseau_commercial?.currency)}
                  </text>
                </group>
              </group>
              <group data-wrap="no">
                <group data-length="autofit" data-hide=""></group>

                <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                  <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                    garantie.demande.etapes.3.panier.tva
                  </Text>
                  <text data-length="80" data-text-align="right" data-space-horizontal="10">
                    {formatNumberEuro(total * 0.2, request.reseau_commercial?.currency)}
                  </text>
                </group>
              </group>

              <group data-wrap="no">
                <group data-length="autofit" data-hide=""></group>

                <group data-gap="10" data-wrap="no" data-width="auto" data-sticky="right">
                  <Text data-length="130" data-text-align="right" data-space-horizontal="10">
                    garantie.demande.etapes.3.panier.totalttc
                  </Text>
                  <text data-length="80" data-text-align="right" data-space-horizontal="10">
                    {formatNumberEuro(total * 1.2, request.reseau_commercial?.currency)}
                  </text>
                </group>
              </group>
            </group>
          )}
        </group>
      </group>

      {request?.articles?.map((article) => {
        let _total = parseFloat(article?.articleReseau?.prix_ht_remise?.toString?.() ?? '') * article.pivot.quantite,
          isAvg = request?.garantie_type?.isAvg && request.satc_attente !== 'refusee';

        total += isAvg ? 0 : _total;
        const qte = article.pivot.quantite;
        if (qte) { }
        return <></>
      })}
    </>
  ) : (
    <></>
  );
};

export default WarrantyBasket;
